<!--APP-SIDEBAR-->
<div class="sticky">
  <div class="app-sidebar__overlay" data-bs-toggle="sidebar"></div>
  <div class="app-sidebar">
    <div class="side-header">
      <a class="header-brand1" routerLink="/dashboard">
        <img src="../assets/images/brand/ic_logo.svg" class="header-brand-img light-logo1">
      </a>
      <a aria-label="Hide Sidebar" class="app-sidebar__toggle" data-bs-toggle="sidebar" (click)="toggleSidebar()">
        <!-- <i class="fe fe-menu" aria-hidden="true"></i> -->
        <i class="humberger-menu" aria-hidden="true"></i>
      </a>
      <!-- LOGO -->
    </div>
    <div class="main-sidemenu">
      <div class="slide-left disabled" id="slide-left">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
          <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
        </svg>
      </div>
      <ul class="side-menu open flex-nowrap">
        <ng-container *ngFor="let menuItem of menuItems;let i=index">
          <li class="side-item" *ngIf="checkModulePermission(menuItem.module)" (click)="getHeaderNotification()"
            [ngClass]="{slide: menuItem.title, 'side-item': menuItem.type, 'is-expanded': menuItem.active }">
            <a class="side-menu__item" [routerLink]="menuItem.type == 'sub' ? null : [menuItem.path]"
              (click)="toggleNavActive(menuItem,i)" routerLinkActive="active">
              <!-- <span class="shape1"></span>
              <span class="shape2"></span> -->
              <span class="side-menu__icon">
                <!-- <i class="fe fe-{{menuItem.icon}} "></i> -->
                <img [ngbTooltip]="menuItem.title" [class]="menuItem.icon"
                  [src]="'../../../../assets/images/svgs/' + menuItem.icon+'.svg'">
              </span>
              <span class="side-menu__label">{{ menuItem.title }}</span>
              <span class="badge side-badge bg-{{ menuItem.badgeClass }} "
                *ngIf="menuItem.badgeClass || menuItem.badgeValue">
                <!-- {{ menuItem.badgeValue }} -->
                {{quotationCount}}
              </span>
              <i *ngIf="menuItem.children && menuItem.type === 'sub'" class="angle fe fe-chevron-right"
                [ngClass]="{ 'd-none': menuItem.badgeClass }"></i>

              <a *ngFor="let internal of menuItem.internalPath" style="display:none" [routerLink]="internal"></a>
            </a>
            <ul class="slide-menu open children" *ngIf="menuItem.children && menuItem.type === 'sub'"
              [ngClass]="{ open: menuItem.active }">


              <ng-container *ngFor="let childrenItem of menuItem.children; let j=index">
                <li *ngIf="checkPagePermission(childrenItem.page)" [ngClass]="{'is-expanded': childrenItem.active,
				   active: childrenItem.selected,'sub-slide': childrenItem.Menusub }">
                  <a class="slide-item avtar" routerLinkActive="active" (click)="toggleNavSubActive(childrenItem);"
                    [routerLink]="!childrenItem.type ? null : [childrenItem.path]" *ngIf="childrenItem.type === 'link'">
                    <span class="side-menu__icon">
                      <img [class]="menuItem.icon" [src]="'../../../../assets/images/svgs/' + childrenItem.icon+'.svg'">
                    </span>
                    <span class="side-menu__label">{{childrenItem.title }}</span>

                    <a *ngFor="let internal of childrenItem.internalPath" style="display:none"
                      [routerLink]="internal"></a>
                  </a>
                  <a href="javascript:;" class="sub-side-menu__item handPoint" *ngIf="childrenItem?.type === 'sub'"
                    [routerLink]="childrenItem?.type ? null : [childrenItem?.path]"
                    (click)="toggleNavActiveSubItem(i,j)">
                    <span class="sub-side-menu__label">{{ childrenItem?.title }}</span>
                    <i
                      class="{{(childrenItem?.active)?'sub-angle fe fe-chevron-right rotade':'sub-angle fe fe-chevron-right'}}"></i>
                  </a>
                  <ul class="{{(childrenItem?.active)?'sub-slide-menu show':'sub-slide-menu'}}"
                    *ngIf="childrenItem?.children && childrenItem?.type === 'sub'"
                    [ngClass]="{ open: childrenItem?.active }">

                    <li *ngFor="let childrenSubItem of childrenItem?.children;let int=index">

                      <a class="sub-slide-item" routerLinkActive="active" *ngIf="childrenSubItem?.type === 'link'"
                        [routerLink]="!childrenSubItem?.type ? null : [childrenSubItem.path]">
                        {{childrenSubItem?.title}}
                      </a>
                    </li>
                  </ul>
                </li>
              </ng-container>
            </ul>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
  <!--/APP-SIDEBAR-->
</div>
<!--/APP-SIDEBAR-->